// extracted by mini-css-extract-plugin
export default {"container":"logsin_container__Xgdnj","loginformcontainer":"logsin_loginformcontainer__2yuIT","newcustomer":"logsin_newcustomer__YGy0K"};